<template>
  <button-dialog-container
    btn-icon="mdi-eye-outline"
    :actif-btn-cancel="false"
    :actif-btn-o-k="false"
    :dialog-viewer="dialog"
    :load="isLoad"
    :is-button-disabled="isBtnDisabled"
    :is-fab="true"
    :is-rounded="false"
    :is-schedule="true"
    :is-small="true"
    :no-btn="noBtn"
    @btn-click="preview()"
    @outside-click="clickOutside()"
  >
    <v-row>
      <preview
        id="preview-schedule"
        ref="preview"
        :is-preview="true"
        :schedule-manager="scheduleManager"
        :show="showPreview"
        @progressFinished="progressFinished()"
      />
    </v-row>
    <v-row
      id="main-button"
      class="button-container text-center"
    >
      <v-col>
        <v-btn
          icon
          x-large
          @click="previous()"
        >
          <v-icon>mdi-skip-previous-circle-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          icon
          x-large
          @click="play()"
        >
          <v-icon>mdi-play-circle-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          icon
          x-large
          @click="pause()"
        >
          <v-icon>mdi-pause-circle-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          icon
          x-large
          @click="next()"
        >
          <v-icon>mdi-skip-next-circle-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row id="textRenderingToCanvas" />
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import preview from "../Player/Preview";

// Connectors
import { ScheduleConnector } from "../Database/ScheduleConnector";

// Controllers
import { ScheduleFileMaker } from "../SchedulePage/ScheduleFileMaker";
import { ScheduleManager } from "../SchedulePage/ScheduleManager";
import { ScheduleReader } from "../SchedulePage/ScheduleReader";

// Tools
const sqlTool = require("../Tools/SQLTools");

export default {
  components: {
    buttonDialogContainer,
    preview,
  },
  props: {
    isBtnDisabled: {
      type: Boolean,
      default: false,
    },
    noBtn: {
      type: Boolean,
      default: false,
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
    playersSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      dialog: false,
      isLoad: true,
      showPreview: false,
      players: [],
      scheduleManager: null,
    };
  },
  watch: {
    openDialog: function (val) {
      this.dialog = val;
    },
    playersSelected: function (val) {
      this.players = val.map((player) => {
        return player.plyrID;
      });
    },
  },
  methods: {
    pause() {
      this.$refs.preview.controlPause();
    },
    play() {
      this.$refs.preview.controlPlay();
    },
    previous() {
      this.$refs.preview.controlPrevious();
    },
    next() {
      this.$refs.preview.controlNext();
    },
    clickOutside() {
      this.showPreview = false;
      this.scheduleManager = null;
      this.dialog = false;
    },
    preview() {
      // Collect all schedules to display
      const schedulesReader = [];
      // Hide preview to reset previous projects
      this.showPreview = false;

      this.scheduleConnector
        .collectScheduleForPlayers(this.players)
        .then((schedules) => {
          schedules.forEach(async (schedule) => {
            schedulesReader.push(
              new ScheduleReader(
                await sqlTool.convertScheduleSQLToJS(schedule),
                "./" + schedule.path,
                this.$store.state.user,
                true
              )
            );
          });

          this.scheduleManager = new ScheduleManager(schedulesReader, null, true, false, this.$store.state.user);

          const schedulefileMaker = new ScheduleFileMaker();
          schedulefileMaker
            .init(this.scheduleManager, "preview", "preview", this.$store.state.user, true)
            .then((fileMaker) => {
              fileMaker
                .make()
                .then(() => {
                  this.scheduleManager
                    .load()
                    .then(() => {
                      this.showPreview = true;
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                })
                .catch((err) => {
                  console.error(err);
                });
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    progressFinished() {
      this.isLoad = false;
    },
  },
};
</script>

<style>
/**
    Text rendering container
  */
#textRenderingToCanvas {
  position: absolute;
  top: -9999px;
  left: -9999px;

  background-color: transparent;
  font-size: 400%;
  white-space: nowrap;
  word-wrap: none;
  opacity: 0;
}

/** 
    Player container
  */
#preview-schedule #playerContainer {
  width: 75vw;
  height: 75vh;
  /* border: 2px solid red; */
}

#preview-schedule #playerContainer .konvajs-content {
  border: 2px solid rgb(44, 44, 44);
}

#preview-schedule #playerContainer .konvajs-content {
  margin: auto;
}

.button-container {
  position: relative;
  z-index: 10;
}

#main-button {
  top: calc(75vh - 64px);
}
</style>
